import ClientLogger from './clientLogger';

const FACEBOOK_SETTINGS_MAP = new Map()
    .set('localhost', {
        socialHost: 'social.stage.homeaway.com',
        appId: 155404361189801
    })
    .set('localhost.com', {
        socialHost: 'social.stage.homeaway.com',
        appId: 155404361189801
    })
    .set('homeaway.localhost', {
        socialHost: 'social.stage.homeaway.com',
        appId: 176278865785256
    })
    .set('vrbo.localhost', {
        socialHost: 'social.stage.homeaway.com',
        appId: 206287156074616
    })
    .set('local.homelidays.es', {
        socialHost: 'social.homeaway.com',
        appId: 958959140937389
    })
    .set('local.abritel.fr', {
        socialHost: 'social.stage.homeaway.com',
        appId: 216495905037464
    })
    .set('local.vrbo.com', {
        socialHost: 'social.stage.vrbo.com',
        appId: 109213082502054
    })
    .set('local.fewo-direkt.de', {
        socialHost: 'social.stage.homeaway.com',
        appId: 160652240666876
    })
    .set('local.fr.homeaway.ca', {
        socialHost: 'social.stage.homeaway.com',
        appId: 128528480560007
    })
    .set('local.homeaway.co.uk', {
        socialHost: 'social.stage.homeaway.com',
        appId: 150947144978961
    })
    .set('local.homeaway.com.ar', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('local.homeaway.at', {
        socialHost: 'social.stage.homeaway.com',
        appId: 216722541738655
    })
    .set('local.homeaway.jp', {
        socialHost: 'social.stage.homeaway.com',
        appId: 216722541738655
    })
    .set('abritel.fr', {
        socialHost: 'social.homeaway.com',
        appId: 210126639025536
    })
    .set('aluguetemporada.com.br', {
        socialHost: 'social.homeaway.com',
        appId: 209459075759568
    })
    .set('fewo-direkt.de', {
        socialHost: 'social.homeaway.com',
        appId: 128002723946928
    })
    .set('fr.homeaway.ca', {
        socialHost: 'social.homeaway.com',
        appId: 176677122390129
    })
    .set('homeaway.co.uk', {
        socialHost: 'social.homeaway.com',
        appId: 191612647555578
    })
    .set('homeaway.com.ar', {
        socialHost: 'social.homeaway.com',
        appId: 177941532264129
    })
    .set('homeaway.at', {
        socialHost: 'social.homeaway.com',
        appId: 257265161001223
    })
    .set('homeaway.com.au', {
        socialHost: 'social.homeaway.com',
        appId: 176962292361464
    })
    .set('stayz.com.au', {
        socialHost: 'social.homeaway.com',
        appId: 176962292361464
    })
    .set('homeaway.ca', {
        socialHost: 'social.homeaway.com',
        appId: 128944923850903
    })
    .set('homeaway.com.co', {
        socialHost: 'social.homeaway.com',
        appId: 168262816569205
    })
    .set('homeaway.com', {
        socialHost: 'social.homeaway.com',
        appId: 174366222619074
    })
    .set('luxury.homeaway.com', {
        socialHost: 'social.homeaway.com',
        appId: 174366222619074
    })
    .set('homeaway.co.in', {
        socialHost: 'social.homeaway.com',
        appId: 223143287703401
    })
    .set('homeaway.co.nz', {
        socialHost: 'social.homeaway.com',
        appId: 455487181161072
    })
    .set('bookabach.co.nz', {
        socialHost: 'social.homeaway.com',
        appId: 455487181161072
    })
    .set('homeaway.dk', {
        socialHost: 'social.homeaway.com',
        appId: 128693037210786
    })
    .set('homeaway.es', {
        socialHost: 'social.homeaway.com',
        appId: 120290661389436
    })
    .set('homeaway.fi', {
        socialHost: 'social.homeaway.com',
        appId: 1295839347151836
    })
    .set('homeaway.it', {
        socialHost: 'social.homeaway.com',
        appId: 230220910326999
    })
    .set('homeaway.com.mx', {
        socialHost: 'social.homeaway.com',
        appId: 1762647237360709
    })
    .set('homeaway.nl', {
        socialHost: 'social.homeaway.com',
        appId: 400009137046079
    })
    .set('homeaway.no', {
        socialHost: 'social.homeaway.com',
        appId: 203285933505567
    })
    .set('homeaway.pt', {
        socialHost: 'social.homeaway.com',
        appId: 1860413537565319
    })
    .set('homeaway.se', {
        socialHost: 'social.homeaway.com',
        appId: 748103608704813
    })
    .set('ownersdirect.co.uk', {
        socialHost: 'social.homeaway.com',
        appId: 132344663970987
    })
    .set('vrbo.com', {
        socialHost: 'social.vrbo.com',
        appId: 232223133460554
    })
    .set('homeaway.gr', {
        socialHost: 'social.homeaway.com',
        appId: 560429950766895
    })
    .set('homeaway.pl', {
        socialHost: 'social.homeaway.com',
        appId: 1710867789211219
    })
    .set('homelidays.com', {
        socialHost: 'social.homeaway.com',
        appId: 278229565951848
    })
    .set('homelidays.it', {
        socialHost: 'social.homeaway.com',
        appId: 963084767161022
    })
    .set('homelidays.es', {
        socialHost: 'social.homeaway.com',
        appId: 692112134295560
    })
    .set('vacationrentals.com', {
        socialHost: 'social.vacationrentals.com',
        appId: 1375264539207158
    })
    .set('homeaway.lk', {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    })
    .set('homeaway.cl', {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    })
    .set('homeaway.co', {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    })
    .set('homeaway.co.in', {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    })
    .set('homeaway.com.ar', {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    })
    .set('homeaway.com.cn', {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    })
    .set('homeaway.com.my', {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    })
    .set('homeaway.com.pe', {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    })
    .set('homeaway.com.sg', {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    })
    .set('homeaway.com.uy', {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    })
    .set('homeaway.ec', {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    })
    .set('homeaway.ph', {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    })
    .set('homeaway.ru', {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    })
    .set('homeaway.co.kr', {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    })
    .set('homeaway.co.th', {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    })
    .set('homeaway.com.vn', {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    })
    .set('homeaway.hk', {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    })
    .set('homeaway.id', {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    })
    .set('homeaway.jp', {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    })
    .set('homeaway.tw', {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    })
    .set('stage.abritel.fr', {
        socialHost: 'social.stage.homeaway.com',
        appId: 218616934825671
    })
    .set('stage.aluguetemporada.com.br', {
        socialHost: 'social.stage.homeaway.com',
        appId: 217815528240857
    })
    .set('stage.fewo-direkt.de', {
        socialHost: 'social.stage.homeaway.com',
        appId: 228890220454386
    })
    .set('stage.fr.homeaway.ca', {
        socialHost: 'social.homeaway.com',
        appId: 103380066421518
    })
    .set('stage.homeaway.co.uk', {
        socialHost: 'social.stage.homeaway.com',
        appId: 178338138886049
    })
    .set('stage.homeaway.co.nz', {
        socialHost: 'social.stage.homeaway.com',
        appId: 106973762796393
    })
    .set('stage.bookabach.co.nz', {
        socialHost: 'social.stage.homeaway.com',
        appId: 106973762796393
    })
    .set('stage.homeaway.com.ar', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('stage.aluguetemporada.com.br', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('stage.homeaway.com.ar', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('stage.homeaway.at', {
        socialHost: 'social.stage.homeaway.com',
        appId: 155443997894330
    })
    .set('stage.homeaway.com.au', {
        socialHost: 'social.stage.homeaway.com',
        appId: 202799066431823
    })
    .set('stage.homeaway.ca', {
        socialHost: 'social.stage.homeaway.com',
        appId: 102098883216214
    })
    .set('stage.homeaway.co', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('stage.homeaway.com', {
        socialHost: 'social.stage.homeaway.com',
        appId: 223242541035731
    })
    .set('luxury-stage.homeaway.com', {
        socialHost: 'social.stage.homeaway.com',
        appId: 223242541035731
    })
    .set('cas-stage.homeaway.com', {
        socialHost: 'social.stage.homeaway.com',
        appId: 223242541035731
    })
    .set('stage.homeaway.dk', {
        socialHost: 'social.stage.homeaway.com',
        appId: 168573503206240
    })
    .set('stage.homeaway.es', {
        socialHost: 'social.stage.homeaway.com',
        appId: 205880156123789
    })
    .set('stage.homeaway.fi', {
        socialHost: 'social.stage.homeaway.com',
        appId: 124898097591508
    })
    .set('stage.homeaway.co.in', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('stage.homeaway.it', {
        socialHost: 'social.stage.homeaway.com',
        appId: 230220910326999
    })
    .set('stage.homeaway.nl', {
        socialHost: 'social.stage.homeaway.com',
        appId: 216036205095513
    })
    .set('stage.homeaway.com.mx', {
        socialHost: 'social.stage.homeaway.com',
        appId: 160107347388893
    })
    .set('stage.homeaway.no', {
        socialHost: 'social.stage.homeaway.com',
        appId: 228413807185035
    })
    .set('stage.homeaway.pt', {
        socialHost: 'social.stage.homeaway.com',
        appId: 192760300771148
    })
    .set('stage.homeaway.se', {
        socialHost: 'social.stage.homeaway.com',
        appId: 190923107625925
    })
    .set('stage.ownersdirect.co.uk', {
        socialHost: 'social.stage.homeaway.com',
        appId: 179318072124302
    })
    .set('stage.vrbo.com', {
        socialHost: 'social.stage.vrbo.com',
        appId: 124450337638403
    })
    .set('stage.homeaway.gr', {
        socialHost: 'social.stage.homeaway.com',
        appId: 629705233827091
    })
    .set('stage.homeaway.pl', {
        socialHost: 'social.stage.homeaway.com',
        appId: 402088900169654
    })
    .set('stage.homelidays.com', {
        socialHost: 'social.stage.homeaway.com',
        appId: 923024571167979
    })
    .set('stage.homelidays.it', {
        socialHost: 'social.homeaway.com',
        appId: 1249106871869873
    })
    .set('stage.homelidays.es', {
        socialHost: 'social.homeaway.com',
        appId: 107072019810406
    })
    .set('stage.vacationrentals.com', {
        socialHost: 'social.stage.vacationrentals.com',
        appId: 740054666164700
    })
    .set('stage.homeaway.lk', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('stage.homeaway.cl', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('stage.homeaway.com.cn', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('stage.homeaway.com.my', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('stage.homeaway.com.pe', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('stage.homeaway.com.sg', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('stage.homeaway.com.uy', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('stage.homeaway.ec', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('stage.homeaway.de', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('stage.homeaway.ph', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('stage.homeaway.ru', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('stage.homeaway.co.kr', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('stage.homeaway.co.th', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('stage.homeaway.com.vn', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('stage.homeaway.hk', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('stage.homeaway.id', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('stage.homeaway.jp', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('stage.homeaway.tw', {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    })
    .set('test.abritel.fr', {
        socialHost: 'social.stage.homeaway.com',
        appId: 216495905037464
    })
    .set('test.fewo-direkt.de', {
        socialHost: 'social.stage.homeaway.com',
        appId: 160652240666876
    })
    .set('test.fr.homeaway.ca', {
        socialHost: 'social.stage.homeaway.com',
        appId: 128528480560007
    })
    .set('test.homeaway.co.uk', {
        socialHost: 'social.stage.homeaway.com',
        appId: 150947144978961
    })
    .set('test.homeaway.com.ar', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('test.homeaway.at', {
        socialHost: 'social.stage.homeaway.com',
        appId: 216722541738655
    })
    .set('test.homeaway.ca', {
        socialHost: 'social.stage.homeaway.ccom',
        appId: 102098883216214
    })
    .set('test.homeaway.com', {
        socialHost: 'social.stage.homeaway.com',
        appId: 214276818594151
    })
    .set('luxury-test.homeaway.com', {
        socialHost: 'social.stage.homeaway.com',
        appId: 214276818594151
    })
    .set('local.homeaway.com', {
        socialHost: 'social.stage.homeaway.com',
        appId: 214276818594151
    })
    .set('cas-test.homeaway.com', {
        socialHost: 'social.stage.homeaway.com',
        appId: 214276818594151
    })
    .set('test.homeaway.com.au', {
        socialHost: 'social.stage.homeaway.com',
        appId: 232355823447356
    })
    .set('test.homeaway.co.nz', {
        socialHost: 'social.stage.homeaway.com',
        appId: 408693902531641
    })
    .set('test.bookabach.co.nz', {
        socialHost: 'social.stage.homeaway.com',
        appId: 408693902531641
    })
    .set('test.homeaway.dk', {
        socialHost: 'social.stage.homeaway.com',
        appId: 128562707222964
    })
    .set('test.homeaway.es', {
        socialHost: 'social.stage.homeaway.com',
        appId: 218505198169378
    })
    .set('test.homeaway.co.in', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('test.homeaway.it', {
        socialHost: 'social.stage.homeaway.com',
        appId: 171544982905463
    })
    .set('test.homeaway.com.mx', {
        socialHost: 'social.stage.homeaway.com',
        appId: 190761167642816
    })
    .set('test.homeaway.nl', {
        socialHost: 'social.stage.homeaway.com',
        appId: 216201598414227
    })
    .set('test.homeaway.no', {
        socialHost: 'social.stage.homeaway.com',
        appId: 171012689625753
    })
    .set('test.homeaway.pt', {
        socialHost: 'social.stage.homeaway.com',
        appId: 221229267894962
    })
    .set('test.homeaway.se', {
        socialHost: 'social.stage.homeaway.com',
        appId: 171502289576202
    })
    .set('test.ownersdirect.co.uk', {
        socialHost: 'social.stage.homeaway.com',
        appId: 205904176119591
    })
    .set('test.vrbo.com', {
        socialHost: 'social.stage.vrbo.com',
        appId: 109213082502054
    })
    .set('test.homeaway.gr', {
        socialHost: 'social.stage.homeaway.com',
        appId: 789666784457552
    })
    .set('test.homeaway.pl', {
        socialHost: 'social.stage.homeaway.com',
        appId: 417671541925591
    })
    .set('test.homelidays.com', {
        socialHost: 'social.stage.homeaway.com',
        appId: 656718087846825
    })
    .set('test.homelidays.it', {
        socialHost: 'social.homeaway.com',
        appId: 1714068882219402
    })
    .set('test.homelidays.es', {
        socialHost: 'social.homeaway.com',
        appId: 958959140937389
    })
    .set('test.vacationrentals.com', {
        socialHost: 'social.stage.vacationrentals.com',
        appId: 1774052049590533
    })
    .set('test.homeaway.lk', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('test.homeaway.cl', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('test.homeaway.co', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('test.homeaway.com.cn', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('test.homeaway.com.my', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('test.homeaway.com.pe', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('test.homeaway.com.sg', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('test.homeaway.com.uy', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('test.homeaway.ec', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('test.homeaway.ph', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('test.homeaway.ru', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('test.homeaway.co.kr', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('test.homeaway.co.th', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('test.homeaway.com.vn', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('test.homeaway.hk', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('test.homeaway.id', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('test.homeaway.jp', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('test.homeaway.tw', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('test.homeaway.fi', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('test.homeaway.de', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    })
    .set('test.stayz.com.au', {
        socialHost: 'social.stage.homeaway.com',
        appId: 232355823447356
    })
    .set('stage.stayz.com.au', {
        socialHost: 'social.stage.homeaway.com',
        appId: 202799066431823
    })
    .set('test.homeaway.com.br', {
        socialHost: 'social.stage.homeaway.com',
        appId: 797315507323547
    })
    .set('test.aluguetemporada.com.br', {
        socialHost: 'social.stage.homeaway.com',
        appId: 797315507323547
    })
    .set('identity-auth-ui-dev-ustst1-01.wvrgroup.internal', {
        socialHost: 'social.stage.homeaway.com',
        appId: 185688351887352
    })
    .set('identity-auth-ui-dev-usstg1-01.wvrgroup.internal', {
        socialHost: 'social.stage.homeaway.com',
        appId: 1183308035090139
    });


// per https://developers.facebook.com/docs/messenger-platform/messenger-profile/supported-locales
// we want to only pick locales that facebook supports
const localeMap = {
    // custom mappings here
    da: 'da_DK',
    de: 'de_DE',
    en: 'en_US',
    es: 'es_LA',
    en_AU: 'en_GB',
    en_GB: 'en_GB',
    en_IN: 'en_GB',
    en_US: 'en_US',
    es_ES: 'es_ES',
    fi: 'fi_FI',
    fr: 'fr_FR',
    fr_CA: 'fr_CA',
    it: 'it_IT',
    nb: 'nb_NO',
    nl: 'nl_NL',
    no: 'nb_NO',
    // base locales here
    no_NO: 'nb_NO',
    pt_BR: 'pt_BR',
    pt_PT: 'pt_PT',
    ko_KR: 'ko_KR',
    nl_NL: 'nl_NL',
    ru_RU: 'ru_RU',
    zh_CN: 'zh_CN',
    zh_HK: 'zh_HK',
    zh_TW: 'zh_TW',
    ja_KS: 'ja_KS',
    pl_PL: 'pl_PL',
    fi_FI: 'fi_FI',
    vi_VN: 'vi_VN',
    sv_SE: 'sv_SE',
    el_GR: 'el_GR',
    es_LA: 'es_LA',
    ja_JP: 'ja_JP',
    tr_TR: 'tr_TR'
};


function getLocale(locale) {
    if (locale) {
        let localParts = locale.split('_');
        if (localParts.length > 2) {
            locale = `${localParts[0]}_${localParts[1]}`;
        }
        let returnLocale = localeMap[locale] ? localeMap[locale] : localeMap[locale.split('_')[0]];
        return returnLocale || 'en_US';
    }
    return 'en_US';
}

/**
 * Get the corresponding facebook settings as per the given domain and locale
 * @param domain String
 * @param locale String
 * @returns {any | {}} Object
 */
function get(domain, locale) {
    if (domain && domain.startsWith('www.')) {
        domain = domain.substring(4);
    }
    let settings = FACEBOOK_SETTINGS_MAP.get(domain);

    if (!settings) {
        ClientLogger.logError(`[ALERT] There are no facebook settings for the specified domain=${domain}`);
        settings = FACEBOOK_SETTINGS_MAP.get('homeaway.com');
    }
    settings.trackingHost = settings.socialHost.replace('social.', 'facebook.');
    settings.locale = getLocale(locale);

    return settings;
}

module.exports = {
    get
};
